import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const TimerComp = (props) => {
  const { t } = useTranslation();
  const [timer, setTimer] = useState(props?.seconds || 59);

  useEffect(() => {
    let startIntervat = setTimeout(() => {
      let localTimer = Number(timer);
      if (localTimer - 1 >= 10) {
        setTimer(localTimer - 1);
      } else if (timer - 1 < 10 && timer - 1 > 0) {
        localTimer = localTimer - 1;
        localTimer = `0${localTimer}`;
        setTimer(localTimer);
      } else {
        clearInterval(startIntervat);
        props.setTimerOver(true);
      }
    }, 1000);
  });

  return (
    <>
      <p style={{ opacity: 0.75 }}>
        {props?.msg
          ? t("common.otpResendCountdownLabel", "{{label}} in 00:{{seconds}}", {
              label: props.msg,
              seconds: timer,
            })
          : t("common.otpResendCountdown", "Resend OTP in 00:{{seconds}}", {
              seconds: timer,
            })}
      </p>
    </>
  );
};

export default TimerComp;
